import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
// import { useAtom } from 'jotai';

// import { loginAtom, renew_sign_in } from '../../lib/auth';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  Avatar,
  Box,
  Grid,
} from '@mui/material';

import {
  IconButton,
  Typography
} from '../../../../components/v2/styled';

import { KnowledgeCourse } from '../../../../models/KnowledgeCourse';
import { KnowledgeSubject } from '../../../../models/KnowledgeSubject';

import HelpersKnowledge from '../../../../actions/helpers/knowledge';
import HelpersLanguage from '../../../../actions/helpers/language';
import { StyledKnowledgeLesson } from './Lesson';

// const { DateTime } = require("luxon");

type Props = {
  knowledgeCourse: KnowledgeCourse;
  knowledgeSubject: KnowledgeSubject;
  i: number;
  setEditingId?: (n:number) => void;
  setSubjectEditOpen?: (b:boolean) => void;
  mutationDestroy?: any;
  collapseLessons?: boolean;
  sx?: any;
  disabled?: boolean;
};

export const StyledKnowledgeSubject: FunctionComponent<Props> = ({knowledgeCourse, disabled, knowledgeSubject, i, setEditingId, setSubjectEditOpen, mutationDestroy, collapseLessons, sx}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  const [collapsed, setCollapsed] = useState<boolean>(true);








  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }







  return (<>
    <Box sx={{
      padding: 2,
      border: '1px solid transparent',
      borderColor: !!disabled ? 'lightgrey' : theme.palette.primary.main,
      borderRadius: 1,
      position: 'relative',
      paddingLeft: 10,
      paddingRight: 12,
      marginBottom: (!!collapseLessons ? 2 : 0),
      ...(!!collapseLessons ? {
        cursor: 'pointer'
      } : {}),
      ...sx
    }} onClick={() => {
      if (!!collapseLessons) setCollapsed(!collapsed);
    }}>
      <Avatar sx={{position: 'absolute', top: 8, left: 8, backgroundColor: !!disabled ? 'lightgrey' : theme.palette.primary.main}}>{HelpersKnowledge.doNumerals(knowledgeCourse?.extra_data?.numerals || 'normal', i+1)}</Avatar>
      <Typography variant="h4" sx={{
        ...(!!disabled ? {
          color: 'lightgrey'
        } : {})
      }}>{selectContentWithId(knowledgeSubject.full_name || {}, knowledgeSubject?.name)}</Typography>
      {selectContentWithId(knowledgeSubject.full_body || {}, ' ').replace(/<[^>]*>?/gm, '').length > 0 && <Typography variant="body2" sx={{
        ...(!!disabled ? {
          color: 'lightgrey'
        } : {})
      }} clean html>{selectContentWithId(knowledgeSubject.full_body || {}, ' ')}</Typography>}
      {!!setEditingId && !!setSubjectEditOpen && <IconButton title="Edit" color="default" onClick={() => {
        setEditingId(knowledgeSubject.id || 0);
        setSubjectEditOpen(true);
      }} sx={{
        position: 'absolute',
        top: 8,
        right: 52
      }}>
        <EditIcon />
      </IconButton>}
      {!!mutationDestroy && <IconButton destroyBtn title="Destroy" color="secondary" onClick={() => {
        mutationDestroy.mutate({
          formData: {
            object: 'knowledge_subject',
            id: knowledgeSubject.id,
            ob: {
              id: knowledgeSubject.id,
            }
          }
        });
      }} sx={{
        position: 'absolute',
        top: 8,
        right: 8
      }}>
        <DeleteIcon />
      </IconButton>}
      {!!collapseLessons && <IconButton title="Open" color="primary" onClick={() => {
        setCollapsed(!collapsed);
      }} sx={{
        position: 'absolute',
        top: 8,
        right: 8
      }}>
        {!!collapsed && <ExpandMoreIcon />}
        {!collapsed && <ExpandLessIcon />}
      </IconButton>}
    </Box>
    {!!collapseLessons && !collapsed && <>
      <Grid container spacing={0}>
        {(knowledgeSubject.knowledge_lessons || []).map((lesson, ii) => <>
          <Grid item xs={12} sx={{paddingLeft: "48px !important", marginBottom: 2}}>
            <StyledKnowledgeLesson
              knowledgeCourse={knowledgeCourse}
              knowledgeSubject={knowledgeSubject}
              knowledgeLesson={lesson}
              i={ii}
            />
          </Grid>
        </>)}
      </Grid>
    </>}
  </>);
}
